/* Rorilio · PDP Crema Renacimiento : comportements de la page source (minuteur, galerie, packs, ajout au panier, accordéons, barre fixe, vidéos, avis). */
(function () {
  if (window.__fennkoPdp) return; window.__fennkoPdp = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Minuteur : fin à minuit dans le fuseau du marché (America/Mexico_City), redémarre chaque jour, caché après la date de fin. */
  function tzNow(tz) {
    try {
      var p = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
      var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
      return { date: o.year + '-' + o.month + '-' + o.day, secs: (parseInt(o.hour, 10) % 24) * 3600 + parseInt(o.minute, 10) * 60 + parseInt(o.second, 10) };
    } catch (e) { var d = new Date(); return { date: d.toISOString().slice(0, 10), secs: d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds() }; }
  }
  function two(n) { return (n < 10 ? '0' : '') + n; }
  document.querySelectorAll('[data-fk-clock]').forEach(function (c) {
    var tz = c.getAttribute('data-tz') || 'America/Mexico_City', until = c.getAttribute('data-until') || '';
    var h = c.querySelector('[data-h]'), m = c.querySelector('[data-m]'), s = c.querySelector('[data-s]');
    function tick() {
      var n = tzNow(tz);
      if (until && n.date > until) { c.style.display = 'none'; return; }
      var r = 86400 - n.secs; if (r >= 86400) r = 0;
      h.textContent = two(Math.floor(r / 3600)); m.textContent = two(Math.floor(r / 60) % 60); s.textContent = two(r % 60);
    }
    tick(); setInterval(tick, 1000);
  });

  /* Galerie */
  document.querySelectorAll('[data-fk-gal]').forEach(function (g) {
    var st = g.querySelector('[data-stage]'), th = [].slice.call(g.querySelectorAll('[data-thumb]'));
    function cur() { return Math.round(st.scrollLeft / (st.clientWidth || 1)); }
    function go(i) { var n = st.children.length; i = (i + n) % n; st.scrollTo({ left: i * st.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); mark(i); }
    function mark(i) { th.forEach(function (t, k) { t.classList.toggle('is-on', k === i); if (k === i && t.parentElement) { var p = t.parentElement; var l = t.offsetLeft - p.offsetLeft; if (l < p.scrollLeft || l + t.offsetWidth > p.scrollLeft + p.clientWidth) p.scrollLeft = l - 8; } }); }
    th.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var l = g.querySelector('[data-prev]'), r = g.querySelector('[data-next]');
    if (l) l.addEventListener('click', function () { go(cur() - 1); });
    if (r) r.addEventListener('click', function () { go(cur() + 1); });
    var t0; st.addEventListener('scroll', function () { clearTimeout(t0); t0 = setTimeout(function () { mark(cur()); }, 80); }, { passive: true });
  });

  /* Accordéons (produit + FAQ) */
  document.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('.fk-acc__h'); if (!h) return;
    var a = h.parentElement, o = a.classList.toggle('is-open'); h.setAttribute('aria-expanded', o ? 'true' : 'false');
  });

  /* Packs + ajout au panier (une seule variante, le pack règle la quantité) */
  document.querySelectorAll('[data-fk-buy]').forEach(function (b) {
    var packs = [].slice.call(b.querySelectorAll('[data-pack]'));
    var qty = (b.querySelector('[data-pack].is-on') || packs[0] || { getAttribute: function () { return '1'; } }).getAttribute('data-qty');
    function pick(p) { qty = p.getAttribute('data-qty'); packs.forEach(function (x) { var on = x === p; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); }); }
    packs.forEach(function (p) {
      p.addEventListener('click', function () { pick(p); });
      p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(p); } });
    });
    var atc = b.querySelector('[data-atc]'), err = b.querySelector('[data-err]');
    if (atc) atc.addEventListener('click', function () {
      var v = b.getAttribute('data-variant');
      if (!window.RorilioFennkoCart) { location.href = '/cart/add?id=' + v + '&quantity=' + qty; return; }
      atc.classList.add('is-busy'); if (err) err.hidden = true;
      window.RorilioFennkoCart.addPack(qty).then(function (st) {
        atc.classList.remove('is-busy');
        if (!window.RorilioFennkoCart.open(st)) location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
      }).catch(function (e) { atc.classList.remove('is-busy'); if (err) { err.textContent = (e && e.message) || 'Error'; err.hidden = false; } });
    });
  });

  /* Barre fixe : visible une fois le bouton d'ajout dépassé, le bouton ramène au choix de l'offre */
  var sticky = document.querySelector('[data-fk-sticky]'), anchor = document.querySelector('[data-fk-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { en.forEach(function (x) { sticky.classList.toggle('is-on', !x.isIntersecting && x.boundingClientRect.top < 0); }); }).observe(anchor);
    var btn = sticky.querySelector('button');
    if (btn) btn.addEventListener('click', function () { var t = document.querySelector('[data-fk-offer]'); if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-fk-to-offer]'); if (!a) return;
    var t = document.querySelector('[data-fk-offer]'); if (!t) return;
    e.preventDefault(); t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  });

  /* Carrousel vidéos */
  document.querySelectorAll('[data-fk-vid]').forEach(function (v) {
    var rail = v.querySelector('.fk-vid__rail');
    v.querySelectorAll('[data-dir]').forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: parseInt(b.getAttribute('data-dir'), 10) * rail.clientWidth * 0.9, behavior: 'smooth' }); }); });
  });

  /* Avis : 4 par page, bouton « Ver más reseñas » */
  document.querySelectorAll('[data-fk-reviews]').forEach(function (w) {
    var items = [].slice.call(w.querySelectorAll('.fk-rv__item')), btn = w.querySelector('[data-more]'), shown = 0, per = 4;
    function more() { for (var i = shown; i < shown + per && i < items.length; i++) items[i].classList.add('is-on'); shown += per; if (btn && shown >= items.length) btn.style.display = 'none'; }
    more(); if (btn) btn.addEventListener('click', more);
  });
})();
